'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AnchorBibDescriptionInput = require('./components/AnchorBibDescriptionInput.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AnchorBibDescriptionInput).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/anchor-bib-description-input/index.js
// module id = 1033
// module chunks = 0